import React from 'react'
import BaseWidgetProvider from '../../base/BaseWidgetProvider'
import AssigmentIcon from '@mui/icons-material/Assignment'
import ActiveMultiJobContainer from './ActiveMultiJobContainer'

/**
 * Provider for the ActiveMultiJob widget.
 *
 * Exposes the master-detail widget for active jobs to the widget system.
 */
class ActiveMultiJobWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'ActiveJobsMasterDetailWidget'

  getName = () => 'Active Jobs Detail'

  getIcon = () => AssigmentIcon

  createWidget = (props) => <ActiveMultiJobContainer {...props} />

  size = { defaultW: 6, defaultH: 6, minW: 5, minH: 6 }

  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight, this.size) }
  }
}

export default ActiveMultiJobWidgetProvider
